import { createContext } from 'react';

const initContext = {
  isPopout: false,
  closePopout: () => null,
};

export const PopoutContext = createContext(initContext);
